import { Injectable, OnDestroy } from '@angular/core';

export interface DocHighlightMessage {
  type: 'dialog-highlight' | 'window-highlight';
  documentId: string;
  entity?: string;
  analyticItem?: string;
}

@Injectable({ providedIn: 'root' })
export class DocHighlightService implements OnDestroy {
  private channel: BroadcastChannel | null = null;
  private onMessage: ((msg: DocHighlightMessage) => void) | null = null;
  private lastReceived: DocHighlightMessage | null = null;

  open(documentId: string, onMessage: (msg: DocHighlightMessage) => void): void {
    this.close();
    this.onMessage = onMessage;
    this.channel = new BroadcastChannel(`doc-view-highlight-${documentId}`);
    this.channel.onmessage = (event: MessageEvent<DocHighlightMessage>) => {
      this.lastReceived = event.data;
      this.onMessage?.(event.data);
    };
  }

  send(msg: DocHighlightMessage): void {
    if (
      this.lastReceived &&
      this.lastReceived.entity === msg.entity &&
      this.lastReceived.analyticItem === msg.analyticItem
    ) {
      this.lastReceived = null;
      return;
    }
    this.channel?.postMessage(msg);
  }

  close(): void {
    this.channel?.close();
    this.channel = null;
    this.onMessage = null;
    this.lastReceived = null;
  }

  ngOnDestroy(): void {
    this.close();
  }
}
